import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter);

const News = () =>
    import( /* webpackChunkName: "news" */ '../view/news/index')
const Home = () =>
    import( /* webpackChunkName: "home" */ '../view/home/index')
const MessageBoard = () =>
    import( /* webpackChunkName: "message_board" */ '../view/messageboard/index')
const Forum = () =>
    import( /* webpackChunkName: "forum" */ '../view/forum/index')
const NonPublic = () =>
    import( /* webpackChunkName: "non_public" */ '../view/nonpublic/index')
const Administration = () =>
    import( /* webpackChunkName: "administration" */ '../view/administration/index')
const TalentTeam = () =>
    import( /* webpackChunkName: "talent_team" */ '../view/talentteam/index')
const Company = () =>
    import( /* webpackChunkName: "company" */ '../view/company/index')   
const Video = () =>
    import( /* webpackChunkName: "video" */ '../view/video/index')
const Search = () =>
    import( /* webpackChunkName: "search" */ '../view/search/index')    
const Layout = () => import('../view/layout/layout')

const router = new VueRouter({
    mode: 'history',
    routes: [
        {
            path: '/',
            component: Layout,
            children: [
                { path: '', component: Home },
            ]
        },
        {
            path: '/news',
            component: Layout,
            children: [
                {
                    path: '',
                    component: News
                }
            ]
        },
        {
            path: '/search',
            component: Layout,
            children: [
                {
                    path: '',
                    component: Search
                }
            ]
        },
        {
            path: '/administration',
            component: Layout,
            children: [
                {
                    path: '',
                    component: Administration
                }
            ]
        },
        {
            path: '/talentteam',
            component: Layout,
            children: [
                {
                    path: '',
                    component: TalentTeam
                }
            ]
        },
        {
            path: '/company',
            component: Layout,
            children: [
                {
                    path: '',
                    component: Company
                }
            ]
        },
        {
            path: '/forum',
            component: Layout,
            children: [
                {
                    path: '',
                    component: Forum
                }
            ],
        },
        {
            path: '/video',
            component: Layout,
            children: [
                {
                    path: '',
                    component: Video
                },
            ]
        },
        {
            path: '/messageboard',
            component: Layout,
            children: [
                {
                    path: '',
                    component: MessageBoard
                },
            ],
        },
        {
            path: '/nonpublic',
            component: Layout,
            children: [
                {
                    path: '',
                    component: NonPublic
                },
            ]
        },
    ]
});

export default router;